import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";

const SUPPORTED = ["ar", "fr", "en"];

// i18next is configured here but the active language is NOT set here — the
// LanguageProvider (src/context/LanguageContext.js) is the single controller
// that calls i18n.changeLanguage() based on ?lang= / localStorage / browser.
i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    // Namespaces are loaded lazily per language from public/locales, so nothing
    // is bundled into the main JS. Components request only the namespace they use.
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    fallbackLng: "fr",
    supportedLngs: SUPPORTED,
    load: "languageOnly",
    ns: ["common"],
    defaultNS: "common",
    fallbackNS: "common",
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: true,
    },
    // Warn (don't break) on missing keys during development.
    saveMissing: process.env.NODE_ENV === "development",
    missingKeyHandler: (lngs, ns, key) => {
      if (process.env.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.warn(`[i18n] missing key "${key}" in ns "${ns}" for ${lngs.join(", ")}`);
      }
    },
  });

export default i18n;
